export default __webpack_public_path__ + "static/media/dropdown.370fe202.svg";